module.exports = __webpack_public_path__ + "img/sec4_03.00f03830.png";